import Vue from 'vue';
import organizationSettingsTransformer from './../../transformers/organizationSettings';
import find from './show';

// When the request succeeds
const success = (resolve) => {
  find();
  resolve();
};

// When the request fails
const failed = (error, reject) => {
  reject(organizationSettingsTransformer.fetch(error.response.data));
};

export default organizationSettings => (
  new Promise((resolve, reject) => {
    Vue.$http.put('/organization_settings/templates', organizationSettings)
    .then(() => {
      success(resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/organizationSettings/updateMessages.js